// extracted by mini-css-extract-plugin
module.exports = {"welcomeCurtain":"welcome_welcomeCurtain__xe5hS","bearWrapper":"welcome_bearWrapper__Rv4C4","copy":"welcome_copy__DlZgq"};